import './responsive_header.less';

import React, {Proptypes} from 'react';
import {Link} from 'react-router';

export default class ResponsiveHeader extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showSlideNotification : false
    };
    this.toggleState =  this.toggleState.bind(this);
  }

  toggleState(){
    var bodyClass = document.querySelector('body').classList;

    if(this.state.showSlideNotification){
      this.setState({
        showSlideNotification : false
      })
      bodyClass.remove('scroll-lock');
    }
    else {
      this.setState({
        showSlideNotification : true
      })
      bodyClass.add('scroll-lock');
    }
  }

  componentDidMount(){

  }

  renderResponsiveHeader(){
    const {props} = this;
    return (
      <div className = {props.responsiveHeaderClassName}>
        <div className = "cf responsive-header-wrp wrapper" >
          <div className = "awb-header-logo-wrp f-l">
            <Link to="/">
              <img className = "awb-logo-elm" src={props.logoImagePath} />
            </Link>
          </div>
          <div className = "f-r awb-btn" onClick={this.toggleState}><span className="icon-three-bars" className = {props.iconClassName}></span></div>
        </div>
    </div>
    );
  }

  renderSlideNotificationBar(){
    return(
      <div className = "slide-notification-bar">
        <div className = "awb-header-logo-wrp cf">
          <Link to="/">
            <img className = "awb-logo-elm" id="slideBarLogo" src="../public/images/landing/logo_white_saffron.png"/>
          </Link>
          <span className = "f-r icon-cross-feather awb-btn" onClick={this.toggleState}></span>
        </div>
        {/*<div className="navigation-elm"><Link>Learn More</Link></div>*/}
        {/* <div className="navigation-elm" onClick={this.toggleState}><Link>Learn More</Link></div> */}
        <div className="navigation-elm" onClick={this.toggleState}><Link to="/signup">Sign Up</Link></div>
        <div className="navigation-elm" onClick={this.toggleState}><Link to="/login">Log In</Link></div>
        <div className="playstore-link-wrp">
          <a className="link" target="_blank" href="http://play.google.com/store/apps/details?id=com.awb.android">
            <img className="playstore-link-elm playstorelogo"  src="../public/images/landing/playstore.png" />
          </a>
          <a className="link" target="_blank" href="https://itunes.apple.com/us/app/airwaybill/id1198529029?ls=1&mt=8">
            <img  className="playstore-link-elm playstorelogo" src="../public/images/landing/appstore.png" />
          </a>
        </div>
      </div>
    )
  }

  render(){
      const {state} = this;
      const renderData = state.showSlideNotification ? this.renderSlideNotificationBar() : this.renderResponsiveHeader();

      return (
          <div>
            {renderData}
          </div>
      )
  }
}

ResponsiveHeader.propTypes = {
  logoImagePath: React.PropTypes.string.isRequired,
  iconClassName: React.PropTypes.string.isRequired,
  responsiveHeaderClassName: React.PropTypes.string.isRequired,
  imageDimensionsClass: React.PropTypes.string,
};



// WEBPACK FOOTER //
// app/header/responsive_header.jsx